import { __extends } from "tslib";
import PropTypes from 'prop-types';
import zhCN from '../locale/zh_CN';
var emptyFn = function () { };
export var propType = {
    className: PropTypes.string,
    locale: PropTypes.object,
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    visible: PropTypes.bool,
    onChange: PropTypes.func,
    onOk: PropTypes.func,
    onSelect: PropTypes.func,
};
export var defaultProp = {
    locale: zhCN,
    style: {},
    visible: true,
    prefixCls: 'dui-calendar',
    className: '',
    onSelect: emptyFn,
    onChange: emptyFn,
    onClear: emptyFn,
    renderFooter: function () {
        return null;
    },
    renderSidebar: function () {
        return null;
    },
};
export var commonMixinWrapper = function (ComposeComponent) { var _a; return _a = (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.getFormat = function () {
                var _a = _this.props, format = _a.format, locale = _a.locale, timePicker = _a.timePicker;
                if (format) {
                    return format;
                }
                return timePicker ? locale.dateTimeFormat : locale.dateFormat;
            };
            _this.focus = function () {
                var _a;
                if (_this.focusElement) {
                    _this.focusElement.focus();
                }
                else {
                    (_a = _this.rootInstance) === null || _a === void 0 ? void 0 : _a.focus();
                }
            };
            _this.saveFocusElement = function (focusElement) {
                _this.focusElement = focusElement;
            };
            _this.saveRoot = function (root) {
                _this.rootInstance = root;
            };
            return _this;
        }
        class_1.prototype.shouldComponentUpdate = function (nextProps) {
            return Boolean(this.props.visible || nextProps.visible);
        };
        return class_1;
    }(ComposeComponent)),
    _a.displayName = 'CommonMixinWrapper',
    _a.defaultProps = ComposeComponent.defaultProps,
    _a.getDerivedStateFromProps = ComposeComponent.getDerivedStateFromProps,
    _a; };
